import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

// const Users = lazy(() => import('../../container/users/Users'));
const UserForm = lazy(() => import('../../container/masters/users/UserForm'));
const DataTable = lazy(() => import('../../container/masters/users/UserListDataTable'));
const AddMachine = lazy(() => import('../../container/masters/machine/AddMachine'));
const MachineDataTable = lazy(() => import('../../container/masters/machine/MachineDataTable'));
const ShiftTable = lazy(() => import('../../container/masters/shifts/ShiftListDataTable'));
const ShiftForm = lazy(() => import('../../container/masters/shifts/ShiftForm'));

const NotFound = lazy(() => import('../../container/pages/404'));

function PagesRoute() {
  return (
    <Routes>
      {/* <Route path="/*" element={<Users />} /> */}
      <Route path="user-form/*" element={<UserForm />} />
      <Route path="user-edit-form/:id" element={<UserForm />} />
      <Route path="dataTable" element={<DataTable />} />
      <Route path="add-machine/*" element={<AddMachine />} />
      <Route path="machines" element={<MachineDataTable />} />
      <Route path="shifts" element={<ShiftTable />} />
      <Route path="shift-form/*" element={<ShiftForm />} />
      <Route path="shfit-edit-form/:id" element={<ShiftForm />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default PagesRoute;
